module.exports = __webpack_public_path__ + "img/图片8.cf07050a.png";